export default {
  "aao": "American Academy of Osteopathy",
  "abs": "American Bible Society",
  "aca": "American Counseling Association",
  "acc": "Accordance Bible Software",
  "acr": "Association of College and Research Libraries",
  "acu": "Abilene Christian University Press",
  "adl": "Auroch Digital",
  "aga": "AAMGA",
  "ahp": "American Society of Health-System Pharmacists",
  "akt": "Arkansas Times",
  "ala": "American Library Association",
  "ali": "American Literatures Initiative / NYU Press",
  "amc": "AMAC Accessibility Solutions & Research Center",
  "amg": "AMG Publishers",
  "amn": "Amnet",
  "amp": "American Payroll Association",
  "ams": "AmeriSearch, Inc.",
  "aph": "American Pharmacists Association",
  "asa": "American Political Science Association",
  "aup": "Andrews University Press",
  "awh": "Association of Women's Health, Obstetric and Ne...",
  "bah": "B and H Publishing Group",
  "bap": "Bancroft Press",
  "bas": "Biblical Archaeology Society",
  "bbm": "Biblemesh",
  "bep": "Business Expert Press",
  "ber": "Berlinica Publishing LLC",
  "bfw": "Bedford, Freeman and Worth",
  "blz": "Blitzprint",
  "bmp": "Bookmark Publishers",
  "brb": "Berghahn Books",
  "brw": "Brewers Association",
  "bsp": "Broadstreet Publishing",
  "bti": "Beneath the Ink",
  "bup": "Baylor University Press",
  "bzn": "Biblezon",
  "car": "Carnegie Endowment For International Peace",
  "cbs": "Christian Book Services",
  "ccb": "United States Conference of Catholic Bishops (U...",
  "cde": "California Department of Education",
  "cfr": "Council on Foreign Relations Inc.",
  "chi": "University of Chicago Press",
  "chm": "Charisma Media",
  "clb": "Crooked Lane Books",
  "clp": "Chalice Press",
  "cmb": "Camino Books, Inc.",
  "cnp": "China National Publications Import & Export (Gr...",
  "cop": "COPD Foundation",
  "cpa": "Chronic Pain Anonymous",
  "cph": "Concordia Publishing House",
  "cpm": "CPM Educational Program",
  "cru": "Cru",
  "cse": "CASE (Council for Advancement and Support of Ed...",
  "csm": "Colonial Society of Massachusetts",
  "cto": "Cato Institute",
  "cup": "Cambridge University Press",
  "cwc": "Connected Wellness Center",
  "daq": "Drawn & Quarterly",
  "dfp": "Detroit Free Press",
  "doe": "Department of Education",
  "dvb": "Diversion Books",
  "ebm": "Edwards Brothers Malloy",
  "eer": "Wm. B. Eerdmans Publishing Co.",
  "egb": "Energy Bar Association",
  "ela": "E. L. Achieve",
  "enb": "Encyclopedia Britannica",
  "enh": "EngenderHealth",
  "fga": "Freer Gallery of Art and Arthur M. Sackler Gallery",
  "fpr": "Foreign Policy Research Institute",
  "fsp": "Free Spirit Publishing",
  "fwd": "FaithWords",
  "gbm": "Guideposts Books and Inspirational Media Division",
  "gcp": "Gateway Create Publishing",
  "gdb": "Green Dragon Books",
  "gpc": "Genealogical Publishing Company",
  "grm": "Great Minds",
  "gui": "Guttmacher Institute",
  "hbp": "Harvard Business Publishing",
  "hbs": "Harvard Business School",
  "hcc": "HarperCollins Christian Publishing",
  "hhp": "Harrison House",
  "hmx": "Humanix Books",
  "hsb": "Humble Bundle",
  "hud": "Hudson Bible",
  "hyp": "Hyperion",
  "inp": "Industrial Press, Inc.",
  "iph": "Innovations in Pharmacy",
  "isd": "InScribe Digital",
  "iwk": "InnerWorkings",
  "jbl": "Jones & Bartlett Learning",
  "kah": "Karetta Hubbard",
  "krg": "Kregel",
  "ksc": "Karen Strauss Consultants",
  "lck": "Lockman Foundation",
  "lct": "Lifechurch.tv",
  "lcu": "Lewis & Clark University",
  "lhn": "Lion Hudson",
  "lmw": "Leadership Ministries Worldwide",
  "lpt": "Lonely Planet",
  "lsc": "Livingstone (The Publishing Services Division o...",
  "mba": "Military Bible Association",
  "mhs": "Minnesota Historical Society Press",
  "mit": "MIT Press Massachusetts Institute of Technology...",
  "mpl": "Milton Public Library",
  "mup": "University of Michigan Press",
  "nbr": "NationBuilder",
  "ncc": "National Council of Churches in the USA",
  "ncl": "National Consumer Law Center",
  "nhp": "New Harbinger Publications",
  "nrp": "New Reformation Publications",
  "nrs": "United States Department of Agriculture Forest ...",
  "nup": "Northwestern University Press",
  "nyu": "New York University Press",
  "oap": "Oklahoma Academy Publishing",
  "oup": "Oxford University Press",
  "ovp": "Oceanview Publishing",
  "pah": "Pan American Health Organization",
  "pal": "Palgrave Macmillan Press",
  "pap": "Paulist Press",
  "pbm": "Pauline Books and Media",
  "phb": "Paul H. Brookes Publishing",
  "pro": "Prospect Press",
  "psu": "The Pennsylvania State University Press",
  "pty": "Printopya",
  "pup": "Princeton University Press",
  "pwp": "Pennywood Press",
  "qrk": "Quirk Books",
  "que": "Quercus",
  "rhi": "Random House Publishing Group",
  "rhp": "Randall House Publishing",
  "rsp": "RockStar Publishing",
  "rut": "Rutgers University Press",
  "san": "Sangari Global Education",
  "sbk": "Sourcebooks, Inc.",
  "sbl": "Society of Biblical Literature",
  "sch": "Scholastic Inc.",
  "scr": "Scribe Inc.",
  "shc": "Springer Healthcare",
  "shp": "Scrub Hill Press",
  "sju": "St. Joseph's University Press",
  "sky": "Skyhorse Publishing",
  "sle": "STM Learning",
  "smb": "Smithsonian Books",
  "smp": "Saint Mary's Press",
  "soa": "State of Alabama",
  "spa": "Self-Publishing Author",
  "sph": "Spencer Hill Press",
  "spi": "Self Publishing, Inc.",
  "spl": "Secant Publishing, LLC",
  "spo": "Self-publishing organization",
  "ssp": "Sullivan Street Press",
  "sts": "Strategic Solution Partners",
  "sun": "SUNY Press",
  "swf": "Swedenborg Foundation / Chrysalis Books",
  "tan": "Tan Books",
  "tmp": "Templeton Foundation Press",
  "trt": "Travelers' Tales, Inc.",
  "tsu": "Truman State University Press",
  "ttp": "Twelve Tables Press",
  "ual": "University of Alabama Press",
  "uaz": "University of Arizona Press",
  "ubc": "University of British Columbia Press",
  "ucb": "University of California Berkeley, Institute of...",
  "uga": "University of Georgia Press",
  "uky": "University of Kentucky",
  "uma": "University of Massachusetts Press",
  "uml": "University of Minnesota Libraries",
  "ump": "University of Minnesota Press",
  "und": "University of Notre Dame Press",
  "unm": "University of New Mexico Press",
  "unp": "University of Nebraska Press",
  "upl": "University of Pennsylvania Libraries",
  "upp": "University of Pennsylvania Press",
  "usg": "United States Geological Survey",
  "usp": "UpSet Press, Inc.",
  "uta": "University of Texas at Austin",
  "uva": "University of Virginia Press",
  "vup": "Vanderbilt University Press",
  "wbk": "World Book",
  "wfu": "Wake Forest University Libraries",
  "whs": "Wisconsin Historical Society",
  "wjk": "Westminster John Knox",
  "wsb": "Word Search Bible",
  "wsp": "Wipf and Stock Publishers",
  "wsu": "Wayne State University Press",
  "wvu": "West Virginia University Press"
}
